export default __webpack_public_path__ + "static/20211202_155553-ce7cb675bae8f63d4e3e79bb44cae92c.jpeg";